import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import StudyCalculatorImg from '../../../images/StudyCalculatorImg.webp';
const TITLE = 'GPA Calculator out of 100 - Calculate Grade out of 100';
const DESCRIPTION = "Calculate your university grade accurately with the university grade calculator. Learn how to calculate the grade out of 100 points easily and assess your academic performance.";
const KEYWORDS = "Grade out of 100, University Grade Calculator, University GPA Calculator, Academic Performance Grade, grading scale calculator, 71 out of 100 grade";
const OG_URL = 'https://do-calculate.com/calculator/en/grade100';
function WeightedGradeCalculator() {
  const [assignments, setAssignments] = useState([
    { name: 'Subject 1', grade: '90', weight: '100' },
    { name: 'Subject 2', grade: '80', weight: '100' },
    { name: 'Subject 3', grade: '70', weight: '100' },
  ]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [weightedScore, setWeightedScore] = useState(0);
  const [weightedGrade, setWeightedGrade] = useState('');
  const calculateWeightedGrade = () => {
    setIsLoading(true);
    setError(null);
    let totalWeightedScore = 0;
    let totalWeight = 0;
    for (const assignment of assignments) {
      const grade = parseFloat(assignment.grade);
      const weight = parseFloat(assignment.weight);
      if (!isNaN(grade) && !isNaN(weight)) {
        totalWeightedScore += (grade / 100) * weight;
        totalWeight += weight;
      }
    }
    if (totalWeight === 0) {
      setError('Please enter valid values for assignments and weights.');
    } else {
      const calculatedWeightedScore = (totalWeightedScore / totalWeight) * 100;
      setWeightedScore(calculatedWeightedScore.toFixed(2));
      const calculatedWeightedGrade = calculateWeightedGradeLetter(calculatedWeightedScore);
      setWeightedGrade(calculatedWeightedGrade);
    }
    setIsLoading(false);
  };
  const calculateWeightedGradeLetter = (weightedScore) => {
    if (weightedScore >= 90) {
      return 'A';
    } else if (weightedScore >= 80) {
      return 'B';
    } else if (weightedScore >= 70) {
      return 'C';
    } else if (weightedScore >= 60) {
      return 'D';
    } else {
      return 'F';
    }
  };

  const addAssignment = () => {
    setAssignments([...assignments, { name: '', grade: '', weight: '' }]);
  };
  const removeAssignment = (index) => {
    const updatedAssignments = [...assignments];
    updatedAssignments.splice(index, 1);
    setAssignments(updatedAssignments);
  };
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedAssignments = [...assignments];
    updatedAssignments[index][name] = name === 'weight' && value === '' ? '100' : value;
    setAssignments(updatedAssignments);
  };
  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} IMAGE={StudyCalculatorImg} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px' }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Welcome to our Grade Calculator! This tool allows you to accurately calculate your university grade out of 100 points. Whether you're looking to find out what a 71 out of 100 grade is, or need a GPA calculator out of 100, we've got you covered. Use our university grade calculator to assess your academic performance easily.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: '16px' }}>University Grade out of 100</h2>
                </div>
                <hr />
                <div className="form-group d-flex align-items-center text-center">
                  <div style={{ width: '125px', marginLeft: '4px' }}>
                    <b><label>Assignment/Exam</label></b>
                  </div>
                  <div style={{ width: '75px', marginLeft: '4px' }}>
                    <b><label>Grade</label></b>
                  </div>
                  <div style={{ width: '75px', marginLeft: '4px', display: 'inline-block' }}>
                    <b><label>Weight</label></b>
                    <button
                      type="button"
                      style={{
                        background: 'none',
                        border: 'none',
                        padding: '0',
                        cursor: 'help',
                        marginLeft: '5px'
                      }}
                      title="Leave the weight field empty if your subjects do not have weights. The default value is 100%"
                    >
                      ℹ️
                    </button>
                  </div>
                </div>
                {assignments.map((assignment, index) => (
                  <div key={index}>
                    <div className="form-group d-flex align-items-center">
                      <input
                        type="text"
                        name="name"
                        placeholder="Subject/Exam"
                        value={assignment.name}
                        style={{ width: '125px', marginLeft: '4px' }}
                        className="form-control ml-2"
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <input
                        type="number"
                        name="grade"
                        placeholder="75"
                        value={assignment.grade}
                        className="form-control ml-2"
                        style={{ width: '75px', marginLeft: '4px' }}
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <input
                        type="number"
                        name="weight"
                        placeholder="100"
                        value={assignment.weight}
                        className="form-control ml-2"
                        style={{ width: '75px', marginLeft: '2px' }}
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <span className="input-group-text "
                        style={{ marginLeft: '4px' }}
                      >%
                      </span>
                      <button className="text-white btn bg-secondary" onClick={() => removeAssignment(index)}>Delete</button>
                    </div>
                    <div>
                      <br />
                    </div>
                  </div>
                ))}
                <button className="text-white btn bg-success" onClick={addAssignment}>Add Subject/Exam</button>
                <div>
                  <br />
                </div>
                <button className="text-white btn bg-success" style={{ fontSize: '20px' }} onClick={calculateWeightedGrade} disabled={isLoading}>
                  {isLoading ? (
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-impaired">Loading...</span>
                    </div>
                  ) : (
                    'Calculate'
                  )}
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-7">
                <br />
                {error && <div className="alert alert-warning"><b><u>Error:</u></b> {error}</div>}
                {weightedScore > 0 &&
                  <div className="bg-light bg-gradient text-dark">
                    <div className="p-3 mb-2 bg-success bg-gradient text-white">
                      <strong>Results</strong>
                    </div>
                    <b>Weighted Grade (out of 100):</b> {weightedScore}%
                    <br />
                    <b>Weighted Grade:</b> {weightedGrade}
                    <br />
                  </div>
                }
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
            <hr />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={CalculatorsType.studyCalculators}></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>{TITLE}</h2></u>
                  <p>To calculate the weighted grade of your university semester, unit, or task, we multiply the grades by their corresponding weights, then add them together, and finally divide the total by the sum of the weights. An example is shown below with the calculation displayed in the results.</p>
                  <table >
                    <tbody>
                      <tr className='gpa-header'>
                        <th>Grade</th>
                        <th>Weight</th>
                        <th>Subject</th>
                      </tr>
                      <tr>
                        <td>66%</td>
                        <td>20 units</td>
                        <td>Data Analysis</td>
                      </tr>
                      <tr>
                        <td>55%</td>
                        <td>10 units</td>
                        <td>Database Fundamentals</td>
                      </tr>
                      <tr>
                        <td>71%</td>
                        <td>10 units</td>
                        <td>Experimental Design</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>Average = (66 × 20 + 55 × 10 + 71 × 10) / (20 + 10 + 10)</p>
                  <p>Therefore, the average grade for student A is 64.5%.</p>
                  <hr />
                </div>
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>Unweighted Subjects</h2></u>
                  <p>
                    If you want to perform an unweighted calculation, simply leave all weight fields empty or make them equal. This method is useful for straightforward calculations of grades out of 100. For example, to find out the grade you need in your final exam to achieve a desired overall grade, use this simple approach.
                  </p>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default WeightedGradeCalculator;
